import React from 'react';
import { IoAlertCircle } from 'react-icons/io5';

const NotSuccessful = ({ onClose, onProceed }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="bg-white w-[500px] p-8 rounded-lg shadow-xl">
        {/* Title */}
        <h2 className="text-2xl font-semibold text-center text-red-600 mb-4 flex items-center justify-center gap-2">
          <IoAlertCircle className="text-3xl" />
          Payment Unsuccessful
        </h2>

        {/* Message */}
        <p className="text-md text-gray-700 text-center mb-6">
          We're sorry, but your payment could not be processed at this time. Please verify your
          payment details or try again later.
        </p>

        {/* Error Details */}
        <div className="space-y-4 mb-8">
          <div className="text-center">
            <p className="text-sm text-gray-500 mt-4">
              Double-check your card details, or contact support if the issue persists.
            </p>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-center gap-6 mt-6">
          <button
            onClick={onClose} // Close the modal
            className="bg-red-500 text-white px-8 py-2 rounded hover:text-black"
          >
            Back
          </button>
          <button
            onClick={onProceed} // Retry the payment
            className="bg-cyan-500 text-white px-8 py-2 rounded hover:text-black"
          >
            Retry
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotSuccessful;
